/**
 * 產生一組隨機 state 字串（防 CSRF）
 * 優先使用 crypto.randomUUID / crypto.getRandomValues，fallback 到 Math.random
 */
export function generateOAuthState() {
  if (typeof window !== 'undefined' && window.crypto) {
    if (typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID().replace(/-/g, '')
    }
    if (typeof window.crypto.getRandomValues === 'function') {
      const arr = new Uint8Array(16)
      window.crypto.getRandomValues(arr)
      return Array.from(arr, (b) => b.toString(16).padStart(2, '0')).join('')
    }
  }
  return `${Date.now().toString(16)}${Math.random().toString(16).slice(2, 18)}`
}

export const KEETA_OAUTH_STATE_KEY = 'keeta_oauth_state'
export const KEETA_CALLBACK_PATH = '/oauth/keeta/callback'
export const KEETA_AUTH_URL = 'https://merchant.mykeeta.com/m/web/openapi/authorize'

/**
 * 組裝 Keeta OAuth 授權連結
 * @param {Object} params
 * @param {string} params.authUrl       Keeta authorize endpoint
 * @param {string} params.appId         Keeta 分配的 appId
 * @param {string} params.redirectUri   前端 callback URL
 * @param {string} params.state         防 CSRF 用
 * @param {string} [params.scope='all'] 授權 scope
 * @returns {string}
 */
export function buildKeetaAuthUrl({ authUrl, appId, redirectUri, state, scope = 'all' }) {
  const query = new URLSearchParams({
    responseType: 'authorization_code',
    appId,
    redirectUri,
    state,
    scope,
  })
  return `${authUrl}?${query.toString()}`
}
